import React from "react";
import Blogs from "../components/Blogs/Blogs";

function BlogPage() {
  return (
    <div>
      <Blogs />
    </div>
  );
}

export default BlogPage;
